module.exports = __webpack_public_path__ + "static/img/banner-read.601c770.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site-image/banner-read.jpg
// module id = TRij
// module chunks = 169